import React from "react";
import SummarizeButton from "./summarize-button";

interface HeaderProps {
  children?: React.ReactNode;
  onSummarize?: () => void;
  isSummarizing?: boolean;
}

export function Header({ children, onSummarize, isSummarizing }: HeaderProps) {
  return (
    <header className="w-full flex items-center justify-between gap-4 px-8 py-4.5 bg-white/80 backdrop-blur-md border-b border-zinc-100/80 sticky top-0 z-40 shrink-0 select-none">
      <div className="flex-1 flex items-center min-w-0">{children}</div>
      {onSummarize && (
        <SummarizeButton
          onSummarize={onSummarize}
          isSummarizing={isSummarizing}
          sparkleOnly={true}
        />
      )}
    </header>
  );
}
